import { DEV } from 'cc/env';
import { _decorator, Sprite, SpriteFrame } from 'cc';
import OrientedComponent, { OrientedBaseProperty } from './OrientedComponent';

const { ccclass, property, requireComponent, menu } = _decorator;

@ccclass('OrientedSpriteProperties')
class OrientedSpriteProperties extends OrientedBaseProperty {
    @property({ tooltip: DEV && '旋轉為該方向時，是否該依據設定調整精靈圖(SpriteFrame)，節點上必需有Sprite組件才會生效' })
    public updateSpriteFrame: boolean = false;
    @property({
        type: SpriteFrame,
        tooltip: DEV && '圖片設定(需有Sprite組件才會生效)',
        visible(this: OrientedSpriteProperties) {
            return this.updateSpriteFrame;
        },
    })
    public spriteFrame: SpriteFrame = null;
}

@ccclass('OrientedSprite')
@requireComponent(Sprite)
@menu('Orientation/OrientedSprite')
export default class OrientedSprite extends OrientedComponent<Sprite> {
    @property({ type: OrientedSpriteProperties, group: '橫式' })
    public readonly landscapeProperties: OrientedSpriteProperties = null;
    @property({ type: OrientedSpriteProperties, group: '直式' })
    public readonly portraitProperties: OrientedSpriteProperties = null;

    public onLoad(): void {
        super.onLoad?.();
        this._tryReleaseSpriteFrame();
    }

    protected updateOrientationProperties(properties: OrientedSpriteProperties) {
        if (properties.updateSpriteFrame) {
            this.target.spriteFrame = properties.spriteFrame;
        }
    }

    protected getTarget() {
        return this.getComponent(Sprite);
    }

    private _tryReleaseSpriteFrame() {
        if (this.game.orientation.supportRotation || this.game.config.orientationConfig.allowManualRotation) {
            return;
        }
        if (this.game.orientation.isLandscape) {
            this.portraitProperties.spriteFrame?.decRef();
            this.portraitProperties.spriteFrame = null;
        } else {
            this.landscapeProperties.spriteFrame?.decRef();
            this.landscapeProperties.spriteFrame = null;
        }
    }
}
